import axios from 'axios';
import { handleResponse } from '../helpers/handle-response';
import apis from '../api';
import Cookies from 'universal-cookie/es6';
// import { Subject } from 'rxjs'

// export const authSubject = new Subject()
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AuthenticationService
Description : Pagina de AuthenticationService donde se autentican los usuarios, 
y se guardan la cuenta de forma local.
Date Autor Modification
================================================================================
2/11/2021 Cristian Andres Pizo Mina - Pagina de AuthenticationService.
23/11/2021 Cristian Andres Pizo Mina - Pagina de AuthenticationService cambie la ruta a remuner http://remunerlite.com.

================================================================================ */

const cookies = new Cookies();

class AuthenticationService {


  constructor() {
    this.getAuthUser = this.getAuthUser.bind(this);
    this.getToken = this.getToken.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.signIn = this.signIn.bind(this);
    this.signOut = this.signOut.bind(this);
    this.getUserType = this.getUserType.bind(this);
  }

  async getUserType() {
    const headers = {
      authorization: cookies.get('token')
    }
    try {
      await apis.getUserType(headers).then(res => {
        localStorage.setItem("type", res.data.TYPE_USER)
        localStorage.setItem("enabled", res.data.ENABLED)
        localStorage.setItem("facturaTech", res.data.NE_FT)
        localStorage.setItem("instance", res.data.INSTANCE)
        localStorage.setItem("vacation", res.data.OPTIONS_FT["VacationProcess"])
        localStorage.setItem("additional", res.data.OPTIONS_FT["AdditionalProcess"])
        localStorage.setItem("novelties", res.data.OPTIONS_FT["VacAbsProcess"])
        localStorage.setItem("tracking", res.data.OPTIONS_FT["TrackProcess"])
        localStorage.setItem("conf_nom", res.data.MIREMUNER_CONF_NOM)
      })
    }
    catch (err) {
      console.log("Wait")
    }
  }

  getAuthUser() {
    const token = cookies.get('token');
    if (token == undefined) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('user_id');
      localStorage.removeItem('client');
      localStorage.removeItem('entity');
      localStorage.removeItem('expired');
      localStorage.removeItem('facturaTech')
      localStorage.removeItem('instance')
      localStorage.removeItem('vacation')
      localStorage.removeItem('additional')
      localStorage.removeItem('pay_modal')
      localStorage.removeItem('novelties')
      localStorage.removeItem('tracking')
      localStorage.removeItem('conf_nom')
    }
    this.getUserType()
    const permissions = {
      token: token,
      type: localStorage.getItem("type"),
      enabled: localStorage.getItem("enabled"),
      instance: localStorage.getItem("instance")
    }
    //console.log(permissions)
    return permissions;
  }

  getToken() {
    return localStorage.getItem('token');
  }

  isAuthenticated() {
    return this.getAuthUser() !== null;
  }


  signIn(username, password) {

    return new Promise((resolve, reject) => {
      apis.postLogin(username, password)
        .then(handleResponse)
        .then(data => {
          cookies.set('token', data.headers["authorization"], { expires: new Date(Date.now() + data.headers["expiration"] * 1000) })
          localStorage.setItem('expired', Date.now());
          localStorage.setItem('token', data.headers["authorization"]);
          localStorage.setItem('user', username);
          localStorage.setItem('user_id', data.data.USER_ID);
          resolve(data.user);
          const headers = {
            authorization: cookies.get('token')
          }
          try {
            apis.getUserType(headers).then(res => {
              if (res.data.TYPE_USER === 'ADMIN'){
                localStorage.setItem("type", res.data.TYPE_USER)
                localStorage.setItem("enabled", res.data.ENABLED)
                localStorage.setItem("client", res.data.CLIENT)
                localStorage.setItem("entity", res.data.ENTITY)
                localStorage.setItem("facturaTech", res.data.NE_FT)
                localStorage.setItem("instance", res.data.INSTANCE)
                localStorage.setItem("vacation", res.data.OPTIONS_FT["VacationProcess"])
                localStorage.setItem("additional", res.data.OPTIONS_FT["AdditionalProcess"])
                localStorage.setItem("vista", "tarjeta")
                localStorage.setItem("novelties", res.data.OPTIONS_FT["VacAbsProcess"])
                localStorage.setItem("tracking", res.data.OPTIONS_FT["TrackProcess"])
                localStorage.setItem("conf_nom", res.data.MIREMUNER_CONF_NOM)
                // if (res.data.TYPE_USER === 'CLIENT') {
                //   localStorage.setItem("number_id", res.data.NUMBER_ID)
                //   localStorage.setItem("contract_id", res.data.CONTRACT_ID)
                //   localStorage.setItem("client", res.data.CLIENT)
                //   localStorage.setItem("entity", res.data.ENTITY)
                // }
              }
              else{
                localStorage.removeItem("expired");
                localStorage.removeItem("token");
                localStorage.removeItem("user");
                localStorage.removeItem("user_id");
                cookies.remove('token');
              }
            })
          }
          catch (err) {
            console.log("Wait")
          }
        })
        .catch(err => {
          reject(err.response.status);
        })
    });
  }



  signOut() {
    cookies.remove('token')
    localStorage.removeItem('expired');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
    localStorage.removeItem('client');
    localStorage.removeItem('entity');
    localStorage.removeItem('type')
    localStorage.removeItem('logo')
    localStorage.removeItem('number_id')
    localStorage.removeItem('enabled')
    localStorage.removeItem('facturaTech')
    localStorage.removeItem('instance')
    localStorage.removeItem('vacation')
    localStorage.removeItem('additional')
    localStorage.removeItem('vista')
    localStorage.removeItem('pay_modal')
    localStorage.removeItem('novelties')
    localStorage.removeItem('tracking')
    localStorage.removeItem('conf_nom')
    window.location.href = "./Login"
  }

}

const authenticationService = new AuthenticationService();
export default authenticationService;
